import styled from 'styled-components';

export const DocumentStyled = styled.div`
    height: 28px;
    cursor: pointer;
    border-radius: 0.475rem;
    &:hover {
        background-color: #E4E6EF
    };
`